import { render, staticRenderFns } from "./LoginPageSVG.vue?vue&type=template&id=19bbf265"
import script from "./LoginPageSVG.vue?vue&type=script&lang=js"
export * from "./LoginPageSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports